import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './rulesForm.scss';
import adjustLUIStyle from '../../utils/adjustLUIStyle';
import { Loader } from '@here/ref-client-ui';
import DeleteSvg from './styles/images/delete-fill.svg'
import ConfirmModal from '../../../sharedUI/ConfirmModal';
import { USER_ROLES } from '../../state/selectedUser/constants';

const RulesForm = ({
        canbeDeleted,
        inputs,
        submitCountryRules,
        resetInputs,
        isLoading,
        formTitle,
        activeUserInfo,
        selectedCountry,
        handleDeleteOd,
        isFieldsChanged,
        hasValidationErrors,
        validationMessage,
        isNewOdRule
    }) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        adjustLUIStyle(document.querySelectorAll('.rf-input-rules-form__submit-btn'), 'lui-button');
    }, []);

    const handleDeleteAction = () => {
        setShowConfirmModal(true);
    };

    const handleConfirmOk = async () => {
        await handleDeleteOd();
    };

    const handleConfirmCancel = () => {
    // Handle cancellation if needed
    console.log('User cancelled the action');
    // Modal will close automatically
    };

    let isSubmitEnabled = false;
    const countries = activeUserInfo.countries && activeUserInfo.countries ? activeUserInfo.countries.map(c => c.code) : [];
    if( 
        activeUserInfo.roles &&  ( 
            (
                activeUserInfo.roles[0] === USER_ROLES.ADMIN &&
                countries.length >0 && 
                countries.includes(selectedCountry)
            )|| 
            ( USER_ROLES.SUPERADMIN === activeUserInfo.roles[0]) 
        )
    )
    { isSubmitEnabled = true;  }
    
    // Determine if submit button should be enabled
    // For new OD rules: enable when no validation errors
    // For existing rules: enable when no validation errors AND changes detected
    const canSubmit = isNewOdRule ? !hasValidationErrors : (!hasValidationErrors && isFieldsChanged);
    
    // Reset button should be enabled when there are changes or when it's a new rule with content
    const canReset = isFieldsChanged || (isNewOdRule && !hasValidationErrors);
        
    return (
        <div className='rf-input-rules-form'>
            <div className='header'>
            <strong className='heading'>{formTitle} Rule</strong>
                {canbeDeleted && <button onClick={handleDeleteAction}><img src={DeleteSvg} alt="delete" /></button>}
            </div>
            {inputs}
            {validationMessage && <p className='validation-message'>{validationMessage}</p>}
            <div className='rf-input-rules-form_bottom_btns'>
                <lui-button  {...(isLoading || !canReset ? {disabled: true } : {})} class='reset-btn'  onClick={resetInputs} secondary >
                        Reset
                </lui-button>
                { ( isLoading ? (
                    <div className='submit-btn loader-container'>
                        <Loader />
                    </div>
                ) : ( 

                    (
                        isSubmitEnabled && 
                         <lui-button {...(!canSubmit ? {disabled: true } : {})} class={['submit-btn'].join(' ')}  onClick={submitCountryRules} >
                            Submit
                         </lui-button>
                    )
                   
                ))}
            </div>
            <ConfirmModal
                isOpen={showConfirmModal}
                title="Delete Item"
                message="Are you sure you want to delete this item? This action cannot be undone."
                onOk={handleConfirmOk}
                onCancel={handleConfirmCancel}
                onClose={() => setShowConfirmModal(false)}
                okText="Delete"
                cancelText="Cancel"
                />
        </div>
    );
};

RulesForm.propTypes = {
    inputs: PropTypes.node,
    submitCountryRules: PropTypes.func.isRequired,
    resetInputs: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    formTitle: PropTypes.string,
    isFieldsChanged: PropTypes.bool,
    hasValidationErrors: PropTypes.bool,
    validationMessage: PropTypes.string,
    isNewOdRule: PropTypes.bool,
    canbeDeleted: PropTypes.bool,
    activeUserInfo: PropTypes.object,
    selectedCountry: PropTypes.string,
    handleDeleteOd: PropTypes.func.isRequired
};

export default RulesForm;